import List from './List.vue';
export default {
  components: {
    List
  },
  data() {
    return {
      dataListTop: [
      // 第一行数据
      {
        first: '',
        second: '智能投资助理1.0',
        third: '智能投资助理2.0',
        last: {
          img: require('@/assets/images/service/investment-assistant/investmentAssistant-advantage-icon.png'),
          text: '智能投资助理3.0'
        }
      }],
      dataListBottom: [
      // 下三行数据
      {
        first: '核心技术',
        second: '关键词匹配',
        third: '自然语言处理',
        last: {
          img: '',
          text: '深度学习;\xa0   神经网络;\xa0   意图识别;\xa0   自然语言处理;\xa0    自然语言学习'
        }
      }, {
        first: '理解能力',
        second: '常规语言交流',
        third: '口语交流',
        last: {
          img: '',
          text: '口语交流;\xa0     金融词汇'
        }
      }, {
        first: '问题解决率',
        second: '50%-60%',
        third: '70%-80%',
        last: {
          img: '',
          text: '>90%'
        }
      }, {
        first: '主要特点',
        second: '无',
        third: '多媒体互动;\xa0     人机协作;\xa0     聊天',
        last: {
          img: '',
          text: '财务诊断;\xa0     百科全书;\xa0     多媒体交互;\xa0     人机协作;\xa0     聊天'
        }
      }]
    };
  }
};